export class Userstatus 
{

    constructor(
        public userStatusId? :number,
        public userStatusName = '',
        public description = '',  
        ) 
        { }

}
